import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/disability-insurance-calculator',
  component: () => import('../../routes/DisabilityInsuranceCalculator.svelte'),
  card: {
    id: 'disability-insurance-calculator',
    title: 'Disability Insurance Calculator',
    description: 'Calculate how much disability income insurance coverage you need to protect your family.',
    icon: 'personal_health',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/disability-insurance-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Disability Insurance Calculator – Income Protection Coverage Calculator',
    description: 'Free disability insurance calculator. Calculate how much disability income coverage you need based on your annual income, expenses, and existing employer benefits.',
  },
};

export default meta;